const mediaKitsAdmin = [
	{
		path: '/agency/media-kits/list',
		name: 'agency-media-kits-list',
		component: () => import('@/views/agency/media-kits/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,media-kits',
		},
	},
	{
		path: '/agency/media-kits/:id',
		name: 'agency-media-kits-show',
		component: () => import('@/views/agency/media-kits/show.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,media-kits',
		},
	},
]

export default mediaKitsAdmin
